import * as THREE from 'three';
import { World } from './World';
import { Npc } from '../character/Npc';
import { NpcSpawnService } from './NpcSpawnService';

export class NpcSpawnPoint {
    constructor(private position: THREE.Vector3, private npcSpawnService: NpcSpawnService) {}

    public spawn(world: World): void {
        const modelPath = this.npcSpawnService.pickModel();
        this.npcSpawnService.loader.load(`../../${modelPath}`, (model) => {
            const npc = new Npc(model, world.animationClips);
            npc.gender = this.npcSpawnService.isFemale(modelPath) ? 'woman' : 'man';
            npc.traverse((object) => {
                object.frustumCulled = false;
            });

            npc.setPosition(this.position.x, this.position.y, this.position.z);

            const forward = new THREE.Vector3(0, 0, 1);
            npc.setOrientation(forward, true);

            const geometry = new THREE.BoxGeometry(0.3, 1.7, 0.3);
            const material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
            geometry.name = 'collisionNpcGeometry';
            material.transparent = true;
            material.opacity = 0;

            const mesh = new THREE.Mesh(geometry, material);
            mesh.name = `npc${THREE.MathUtils.generateUUID().substring(0, 3)}`;
            npc.add(mesh);
            npc.isPlayer = false;
            world.add(npc);
            if (world.navMesh) {
                npc.initNpcOnNavMesh(world.navMesh);
            } else {
                npc.initNpc();
            }
        });
    }
}
